import axios from 'axios';
import store from '../store'

class WhitelabelRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    async getWhitelabelByApiKey(apiKey) {
        return axios.get(`${this.basePath}/whitelabel/by-api-key/${apiKey}`);
    }
}

export default new WhitelabelRepository();
